import { memo } from 'react';
import { useDispatch } from 'react-redux';
import DTCopyTextSendMacroView from '../DTCopyTextSendMacroView';
import { withConfirmation } from '../../../DTConfirmationView/withConfirmation';
import { addAllowlistItem } from 'actions/tools/CommonInterface/Returns/AsyncReturnActions';

const DTAddOrderToReturnAllowListThenSendMacro = () => {
  const dispatch = useDispatch();

  const handleNextButtonClick = async () => await dispatch(addAllowlistItem());

  return (
    <DTCopyTextSendMacroView
      buttonText={'ADD TO ALLOWLIST'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={true}
      popupConfirmationText={'You are about to add the selected order to return allowlist.'}
      customErrorMessage={'There was a problem adding the order to allow list for return.'}
    />
  );
};

export default memo(withConfirmation(DTAddOrderToReturnAllowListThenSendMacro));
